<template>
  <v-form
    ref="form"
    lazy-validation
    class="app-form"
    @submit.prevent="onSubmit"
  >
    <section v-if="isLoading" class="loading">
      <v-progress-circular indeterminate color="primary" />
    </section>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-form
          ref="formSearchPlate"
          lazy-validation
          class="search-plate"
          @submit.prevent="searchPlate"
        >
          <v-text-field
            v-model="form.veiculo.placa"
            v-mask="'AAA-#X##'"
            label="Placa *"
            type="text"
            placeholder="Ex: PMD-9876"
            outlined
            dense
            :rules="[rules.required]"
            :loading="isLoading"
            :disabled="disabledSearch"
            class="search-plate__field mt-2"
          />
          <v-btn
            depressed
            color="primary"
            class="search-plate__btn mt-2"
            type="submit"
            :disabled="isLoading || disabledSearch"
          >
            Pesquisar
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <v-row v-if="!isLoading && form.veiculo.renavam" class="mt-0">
      <v-col cols="12" md="4" sm="4" class="pt-0">
        <v-radio-group v-model="form.tipoServicos.id" :rules="[rules.required]">
          <template #label>
            <strong>Serviço*</strong>
          </template>
          <v-radio
            v-for="servico in tipoServicosTransportadorasItems"
            :key="servico.id"
            :label="servico.descricao"
            :value="servico.id"
          />
        </v-radio-group>
      </v-col>
      <v-col cols="12" md="4" sm="4" class="pt-0">
        <v-radio-group
          v-if="form.tipoServicos.id === tipoServicoRegularId"
          v-model="form.veiculo.areaAtuacao.id"
          :rules="[rules.required]"
        >
          <template #label>
            <strong>Área de Atuação*</strong>
          </template>
          <v-radio
            v-for="area in tipoAreaAtuacaoItems"
            :key="area.id"
            :label="area.descricao"
            :value="area.id"
            :rules="[rules.required]"
          />
        </v-radio-group>
      </v-col>

      <v-col cols="12" md="4" sm="4">
        <v-select
          v-if="form.veiculo.areaAtuacao.id === regiaoMetropolitanaId"
          v-model="form.veiculo.regiaoMetropolitana"
          :items="regioesMetropolitanasItems"
          :rules="[rules.required]"
          item-text="descricao"
          :item-value="(v) => ({ id: v.id })"
          label="Região Metropolitana *"
          return-object
          dense
          outlined
          :disabled="isLoading"
          :loading="isLoadingRegiaoMetropolitana"
        />
      </v-col>

      <!-- <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="form.veiculo.chassiNumero"
          label="Número Chassi *"
          placeholder="Ex: Digite o chassi"
          outlined
          dense
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="form.veiculo.renavam"
          label="Número Renavam *"
          placeholder="Ex: Digite o renavam"
          outlined
          dense
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col> -->

      <v-col cols="12" md="4" sm="4">
        <v-select
          v-model="form.veiculo.tipoVeiculo"
          :items="tipoVeiculoItems"
          :rules="[rules.required]"
          item-text="descricao"
          :item-value="(v) => ({ id: v.id })"
          label="Tipo Veículo *"
          return-object
          dense
          outlined
          :disabled="isLoading"
        />
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-autocomplete
          v-model="form.veiculo.modeloCarroceria.fabricanteCarroceria"
          :items="fabricante"
          item-text="nome"
          :item-value="(v) => ({ id: v.id })"
          label="Fabricante"
          dense
          outlined
        />
      </v-col>
      <v-col cols="12" md="4" sm="4">
        <v-autocomplete
          v-model="form.veiculo.modeloCarroceria.id"
          :items="carroceria"
          item-text="nome"
          :item-value="(v) => v.id"
          label="Modelo Carroceria"
          dense
          outlined
          :loading="isLoadingCarroceria"
          :disabled="disabledCarroceria"
        />
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-text-field
          v-model="form.veiculo.potencia"
          label="Potência *"
          placeholder="Ex: Digite a potencia"
          outlined
          :rules="[rules.required]"
          dense
          min="0"
          type="number"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-text-field
          v-model="form.veiculo.lotacaoSentados"
          label="Lotação Sentados *"
          :rules="[rules.required]"
          placeholder="Ex: Digite a quantidade"
          outlined
          dense
          type="number"
          min="0"
        />
      </v-col>

      <v-col cols="12" md="4" sm="6">
        <v-text-field
          v-model="form.veiculo.lotacaoEmPe"
          label="Lotação em Pé"
          placeholder="Ex: Digite a quantidade"
          outlined
          dense
          type="number"
          min="0"
        />
      </v-col>

      <v-col cols="12" md="6" sm="6" class="pt-0">
        <v-checkbox v-model="form.veiculo.possuiAr" :disabled="isLoading">
          <template #label>
            <strong>Possui Ar?</strong>
          </template>
        </v-checkbox>
        <!-- <v-radio-group
          v-model="form.veiculo.possuiAr"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui Ar?</strong>
          </template>
          <v-radio
            :key="'sim'"
            label="Sim"
            :value="'true'"
          />
          <v-radio
            :key="'nao'"
            label="Não"
            :value="'false'"
          />
        </v-radio-group> -->
      </v-col>

      <v-col cols="12" md="6" sm="6" class="pt-0">
        <v-checkbox
          v-model="form.veiculo.possuiSanitario"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui Sanitário?</strong>
          </template>
        </v-checkbox>
        <!-- <v-radio-group
          v-model="form.veiculo.possuiSanitario"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui Sanitário?</strong>
          </template>
          <v-radio
            :label="`Sim`"
            :value="'true'"
          />
          <v-radio
            :label="`Não`"
            :value="'false'"
          />
        </v-radio-group> -->
      </v-col>

      <v-col cols="12" md="6" sm="6" class="pt-0">
        <v-checkbox v-model="form.veiculo.possuiWifi" :disabled="isLoading">
          <template #label>
            <strong>Possui WI-FI?</strong>
          </template>
        </v-checkbox>
        <!-- <v-radio-group
          v-model="form.veiculo.possuiWifi"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui WIFI?</strong>
          </template>
          <v-radio
            :label="`Sim`"
            :value="'true'"
          />
          <v-radio
            :label="`Não`"
            :value="'false'"
          />
        </v-radio-group> -->
      </v-col>

      <v-col cols="12" md="6" sm="6" class="pt-0">
        <v-checkbox
          v-model="form.veiculo.possuiAcessibilidade"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui Acessibilidade?</strong>
          </template>
        </v-checkbox>
        <!-- <v-radio-group
          v-model="form.veiculo.possuiAcessibilidade"
          :disabled="isLoading"
        >
          <template #label>
            <strong>Possui Acessibilidade?</strong>
          </template>
          <v-radio
            :label="`Sim`"
            :value="'true'"
          />
          <v-radio
            :label="`Não`"
            :value="'false'"
          />
        </v-radio-group> -->
      </v-col>

      <v-col cols="12" md="3" sm="6">
        <v-text-field
          v-model="form.veiculo.ultAnoLicenciamento"
          label="Último Ano Licenciamento *"
          placeholder="Ex: 2020"
          outlined
          dense
          min="0"
          type="number"
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="3" sm="6">
        <v-text-field
          v-model="form.veiculo.anoFabricacao"
          label="Ano Fabricação *"
          placeholder="Ex: 2020"
          outlined
          dense
          min="0"
          type="number"
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="3" sm="6">
        <v-text-field
          v-model="form.veiculo.chassiAno"
          label="Ano Chassi *"
          placeholder="Ex: 2020"
          outlined
          dense
          min="0"
          type="number"
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="3" sm="6">
        <v-text-field
          v-model="form.veiculo.carroceriaAnofabricacao"
          label="Ano Fabricação Carroceria"
          placeholder="Ex: 2020"
          outlined
          dense
          min="0"
          type="number"
        />
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="form.veiculo.cor.nome"
          label="Cor *"
          outlined
          dense
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <v-text-field
          v-model="form.veiculo.combustivel.nome"
          label="Combustível *"
          outlined
          dense
          :disabled="true"
        />
      </v-col>

      <!-- <v-col
        cols="12"
        md="6"
        sm="6"
      >
        <v-text-field
          v-model="form.veiculo.marcaChassi.nome"
          label="Marca Chassi *"
          outlined
          dense
          :rules="[rules.required]"
        />
      </v-col> -->

      <v-col cols="12" md="12" sm="12">
        <v-text-field
          v-model="form.veiculo.marcaModelo.nome"
          label="Marca Modelo *"
          outlined
          dense
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-text-field
          v-model="form.veiculo.ufJurisdicao.nome"
          label="UF *"
          outlined
          dense
          :rules="[rules.required]"
          :disabled="true"
        />
      </v-col>

      <v-col cols="12" md="12" sm="12">
        <v-btn depressed type="submit" color="primary"> Continuar </v-btn>
      </v-col>
    </v-row>
    <!-- <pre>{{ form }}</pre> -->
  </v-form>
</template>

<script>
import VeiculoService from "@/services/sit-pedidos/veiculo.service";
import { mapState, mapActions } from "vuex";
import { mask } from "vue-the-mask";
import { Subject } from "rxjs";
import {
  tap,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs/operators";
import pedidoService from "@/services/sit-pedidos/pedido.service";
import { result } from "lodash";

const actions = mapActions("sitPedidos", ["setFormStep", "setFormPedido"]);

export default {
  name: "VeiculoForm",
  directives: {
    mask,
  },
  data: () => ({
    tipoServicosTransportadorasItems: [],
    tipoAreaAtuacaoItems: [],
    tipoVeiculoItems: [],
    regioesMetropolitanasItems: [],
    isLoading: false,
    isLoadingCarroceria: false,
    disabledCarroceria: true,
    error: null,
    subjectVeiculoService: null,
    regiaoMetropolitanaId: 1, // XXX: Referente ao Id da Area de Atuação Metropolitana, ATENÇÃO: se mudar no banco deve mudar aqui também o ID
    tipoServicoRegularId: 1, // XXX: Referente ao Id do Tipo de Serviço Regular, ATENÇÃO: se mudar no banco deve mudar aqui também o ID
    isLoadingRegiaoMetropolitana: false,
    form: {
      tipoPedido: "INCLUSAO_VEICULO",
      transportadora: {
        id: null,
      },
      tipoServicos: {
        id: null,
      },
      veiculo: {
        placa: null,
        chassiNumero: null,
        potencia: null,
        lotacaoSentados: null,
        lotacaoEmPe: null,
        possuiAr: false,
        possuiSanitario: false,
        possuiWifi: false,
        possuiAcessibilidade: false,
        renavam: null,
        ultAnoLicenciamento: null,
        anoFabricacao: null,
        chassiAno: null,
        carroceriaAnofabricacao: null,
        regiaoMetropolitana: {
          id: null,
          descricao: null,
        },
        tipoVeiculo: {
          id: null,
          nome: null,
        },
        cor: {
          id: null,
          nome: null,
        },
        combustivel: {
          id: null,
          nome: null,
        },
        marcaChassi: {
          id: null,
          nome: null,
        },
        marcaModelo: {
          id: null,
          nome: null,
        },
        ufJurisdicao: {
          id: null,
          nome: null,
        },
        areaAtuacao: {
          id: null,
        },
        modeloCarroceria: {
          id: null,
          fabricanteCarroceria: {
            id: null,
          },
        },
      },
      serviceSubject: null,
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      alreadyExists: (value) => (value ? "Placa já registrada" : false),
    },
    fabricante: [],
    carroceria: [],
    disabledSearch: false,
  }),
  computed: {
    ...mapState("transportadora", ["transportadora"]),
  },
  watch: {
    "form.tipoServicos.id": function (newValue, oldValue) {
      if (newValue === this.tipoServicoRegularId) {
        this.loadAreaAtuacaoTransportadora();
      } else {
        this.form.veiculo.areaAtuacao = { id: null };
      }
    },
    "form.veiculo.areaAtuacao.id": function (newValue, oldValue) {
      if (newValue === this.regiaoMetropolitanaId) {
        this.loadRegiaoMetropolitana();
      } else {
        this.form.veiculo.regiaoMetropolitana = null;
      }
    },
    "form.veiculo.modeloCarroceria.fabricanteCarroceria.id": function () {
      if (this.form.veiculo.modeloCarroceria.fabricanteCarroceria.id) {
        this.loadCarrocerias();
      }
    },
  },
  mounted() {
    this.populeTransportadoraForm();
    this.loadTipoServicosTransportadora();
    this.loadTipoVeiculo();
    this.loadVeiculo();
    this.loadFabricantes();
  },
  methods: {
    ...actions,
    loadTipoServicosTransportadora() {
      const { id } = this.transportadora;
      VeiculoService.getTipoServicoTransportadora(id).subscribe((res) => {
        this.tipoServicosTransportadorasItems = res.filter(s =>  s.id == 3); // FRETAMENTO;
      });
    },
    loadAreaAtuacaoTransportadora() {
      const { id } = this.transportadora;
      VeiculoService.getAreasAtuacaoTransportadora(id).subscribe((res) => {
        this.tipoAreaAtuacaoItems = res;
      });
    },
    loadTipoVeiculo() {
      VeiculoService.getTipoVeiculo().subscribe((res) => {
        this.tipoVeiculoItems = res;
      });
    },
    getVeiculoByPlaca(value) {
      this.subjectVeiculoService.next(value);
    },
    loadVeiculo() {
      this.rules.invalid = null;
      this.subjectVeiculoService = new Subject();
      this.subjectVeiculoService
        .pipe(debounceTime(1000))
        .pipe(distinctUntilChanged())
        .pipe(
          tap((value) => {
            this.isLoading = true;
          })
        )
        .pipe(
          switchMap((value) => {
            if (!value) {
              return of(null);
            }

            const placa = value.replace("-", "");

            return VeiculoService.getDadosVeiculo(placa);
          })
        )
        .subscribe(
          (result) => {
            this.form.veiculo = { ...this.form.veiculo, ...result };
            this.isLoading = false;
          },
          (error) => {
            this.isLoading = false;
          }
        );
    },
    populeTransportadoraForm() {
      this.form = { ...this.form, transportadora: { ...this.transportadora } };
    },
    loadRegiaoMetropolitana() {
      this.isLoadingRegiaoMetropolitana = true;
      VeiculoService.getRegioesMetropolitanas().subscribe(
        (res) => {
          this.regioesMetropolitanasItems = res;
          this.isLoadingRegiaoMetropolitana = false;
        },
        (error) => {
          this.isLoadingRegiaoMetropolitana = false;
        }
      );
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.form.veiculo.placa = this.form.veiculo.placa.replace("-", "");
        this.form.veiculo.marcaChassi = null;
        const areaAtuacaoInterurbanoId = 2;
        this.form.veiculo.areaAtuacao = {
          id:
            this.form.tipoServicos.id === 3
              ? areaAtuacaoInterurbanoId
              : this.form.veiculo.areaAtuacao.id,
        };

        pedidoService.createInclusaoVeiculo(this.form).subscribe(
          (res) => {
            this.isLoading = false;
            this.setFormPedido(res);
            this.setFormStep(2);
          },
          (error) => {
            this.isLoading = false;
          }
        );
      }
    },
    searchPlate() {
      const isValid = this.$refs.formSearchPlate.validate();

      if (isValid) {
        this.isLoading = true;
        const placa = this.form.veiculo.placa.replace("-", "");
        VeiculoService.getDadosVeiculo(placa).subscribe(
          (res) => {
            this.form.veiculo = { ...this.form.veiculo, ...res };
            this.isLoading = false;
            this.disabledSearch = true;
          },
          (error) => {
            this.isLoading = false;
          }
        );
      }
    },
    loadFabricantes() {
      this.serviceSubject = new Subject();
      pedidoService.getFabricantes().subscribe((result) => {
        this.fabricante = result;
      });
    },
    loadCarrocerias() {
      this.isLoadingCarroceria = true;
      const {
        fabricanteCarroceria: { id },
      } = this.form.veiculo.modeloCarroceria;
      pedidoService.getCarroceria(id).subscribe((result) => {
        this.carroceria = result;
        this.isLoadingCarroceria = false;
        this.disabledCarroceria = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.search-plate {
  display: flex;
  margin-top: 10x;
  &__field {
    margin-right: 15px;
  }
}
</style>
